/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';

function Buttons({ children, className }) {
  return (
    <div className={`dtv-html5-c-detail-container__buttons ${className}`}>
      {children}
    </div>
  );
}

Buttons.defaultProps = {
  className: '',
};

Buttons.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default memo(withInteractiveFocusable()(memo(Buttons)));
